import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { GET_CURRENT_USER_JSSIP_CONFIG } from '../graphql/queries';

export const useJsSipConfig = () => {
  const { workspaceId: routeWorkspaceId } = useParams();

  const { data, loading, error } = useQuery(GET_CURRENT_USER_JSSIP_CONFIG, {
    variables: { workspaceId: routeWorkspaceId },
    fetchPolicy: 'cache-first',
    skip: !routeWorkspaceId,
  });

  return {
    config: data?.getCurrentUserJssipConfig,
    hasJsSipExtension: Boolean(data?.getCurrentUserJssipConfig),
    loading,
    error,
  };
};
